import script from "./Offer.vue?vue&type=script&setup=true&lang=js"
export * from "./Offer.vue?vue&type=script&setup=true&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=720a362b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720a362b"]])

export default __exports__